module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageArticleDetail":{"articleCategories":{"title":"Kategorie"},"author":{"title":"O žádném autorovi | O autorovi | O autorech | O autorech"},"backToArticles":"Zpět na blog","breadcrumbs":{"index":"Blog"},"latestArticles":"Další články"}}}')
  delete Component.options._Ctor
}
